var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"settings-hide-msg"},[_vm._v(" No settings for this app (at the funnel level)... You can check account wide settings... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }